export const TIPO_CREACION = {
  MANUAL: 1,
  IMPORTADO: 2,
} as const

export type TipoCreacionType =
  (typeof TIPO_CREACION)[keyof typeof TIPO_CREACION]
